module.exports = require('@atlassian/trello-error-ext') 'Attachment::LimitExceeded'



// WEBPACK FOOTER //
// ./app/scripts/views/attachment/attachment-limit-exceeded-error.coffee